import React, { useState } from 'react'
 
 
import BankList from './BankList';
import BankForm from './BankForm';

const Bank= () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);

  return (
    <>
      {fromIsShown ? (
          <BankForm addForm={setFromIsShown} update={upData} />
        ) : (
          <BankList addForm={setFromIsShown} update={setUpData} />
        )}  
    </>
  )
}

export default Bank